"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var no_case_1 = require("no-case");
var upper_case_1 = require("upper-case");
function constantCase(input, options) {
    if (options === void 0) { options = {}; }
    return no_case_1.noCase(input, tslib_1.__assign({ delimiter: "_", transform: upper_case_1.upperCase }, options));
}
exports.constantCase = constantCase;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/constant-case/dist/index.js
// module id = 1234
// module chunks = 0